// src/hooks/useUTM.js
import { useEffect } from 'react';

function detectPlatform(params) {
  const source = params.get('utm_source')?.toLowerCase();
  const ttclid = params.get('ttclid');
  const gclid = params.get('gclid');
  const fbclid = params.get('fbclid');
  const gadSource = params.get('gad_source');

  if (ttclid) return 'TikTok';
  if (gclid || gadSource) {
    if (gadSource === '1') return 'Google Search';
    if (gadSource === '2') return 'Google Display';
    return 'Google/YouTube';
  }
  if (source === 'instagram' || source === 'ig') return 'Instagram';
  if (source === 'whatsapp') return 'WhatsApp';
  if (source === 'fb' || source === 'facebook' || fbclid) return 'Facebook';
  if (source === 'youtube') return 'YouTube';
  if (source === 'tiktok') return 'TikTok';
  if (source) return source;
  return 'Organic/Direct';
}

export function useUTM() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const fbclid = params.get('fbclid');
    const ttclid = params.get('ttclid');
    const gclid  = params.get('gclid');
    const utm_source   = params.get('utm_source');
    const utm_medium   = params.get('utm_medium');
    const utm_campaign = params.get('utm_campaign');
    const utm_content  = params.get('utm_content');
    const utm_term     = params.get('utm_term');
    const gad_source      = params.get('gad_source');
    const gad_campaignid  = params.get('gad_campaignid');

    // কিছু না থাকলে save করার দরকার নেই
    const hasTrackingData =
      fbclid || ttclid || gclid || utm_source || gad_source;

    if (!hasTrackingData) return;

    const newVisit = {
      platform:      detectPlatform(params),
      utm_source:    utm_source    || null,
      utm_medium:    utm_medium    || null,
      utm_campaign:  utm_campaign  || null,
      utm_content:   utm_content   || null,
      utm_term:      utm_term      || null,
      fbclid:        fbclid        || null,
      ttclid:        ttclid        || null,
      gclid:         gclid         || null,
      gad_source:    gad_source    || null,
      gad_campaignid: gad_campaignid || null,
      page:          window.location.pathname,
      timestamp:     new Date().toISOString(),
    };

    // আগের history নাও
    let history = [];
    try {
      const existing = sessionStorage.getItem('utm_history');
      if (existing) history = JSON.parse(existing);
    } catch (_) {}

    // Duplicate check — একই fbclid/ttclid/gclid আগে save হয়ে গেলে আবার save করবে না
    const isDuplicate = history.some(
      (v) =>
        (fbclid && v.fbclid === fbclid) ||
        (ttclid && v.ttclid === ttclid) ||
        (gclid  && v.gclid  === gclid)
    );

    if (!isDuplicate) {
      history.push(newVisit);
      sessionStorage.setItem('utm_history', JSON.stringify(history));
    }
  }, [window.location.href]);
}

// Checkout এর সময় call করো
export function getUTMHistory() {
  try {
    const data = sessionStorage.getItem('utm_history');
    return data ? JSON.parse(data) : [];
  } catch (_) {
    return [];
  }
}